module.exports = __webpack_public_path__ + "img/opinion3.e81a606c.jpg";